import { NotificationsTab } from '@/features/settings/NotificationsTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/notifications')({
  component: NotificationsTab,
});
